<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8WaZdr/tc-custom/9781595585745.jpg?1726871191360" alt="This image is the cover for the book History in the Making"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">History in the Making
      </h1>
      <p class="bookDescription body article font2">
        <b>The popular, “thought-provoking study” that explores how contemporary prejudices change the way each generation looks at the nation’s past (<i>Library Journal</i>).</b><br/>  <br/> Historian Kyle Ward, the acclaimed co-author of <i>History Lessons</i>, offers another fascinating look at the biases inherent in the way we think about, write about, and teach our own history. Juxtaposing passages from US history textbooks of different eras, <i>History in the Making</i> provides new perspectives on familiar historical events, and sheds light on the ways they have been represented over generations.<br/>  <br/> Covering subjects that span two hundred years, from Columbus’s arrival to the Boston Massacre, from women’s suffrage to Japanese internment, <i>History in the Making</i> exposes the changing values, priorities, and points of view that have framed—and reframed—our past.<br/>  <br/> “Interesting and useful . . . convincingly illustrates how texts change as social and political attitudes evolve.” —<i>Booklist</i><br/>  <br/> “Students, teachers, and general readers will learn more about the past from these passages than from any single work, however current, that purports to monopolize the truth.” —Ray Raphael, author of <i>Founding Myths</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kyle Ward
      </h2>
      
      <p class="authorDescription body article">Kyle Ward is an assistant professor of history and political science at Vincennes University, a co-author of History Lessons, and the author of In the Shadow of Glory. He lives in Terre Haute, Indiana.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The New Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b5973b20